module.exports = __webpack_public_path__ + "./docs/img/icon-curl.55b99b7c308910e1cc232240f02e954b.svg";